import { render, staticRenderFns } from "./ModifyCurrencyPopup.vue?vue&type=template&id=00a0a23b"
import script from "./ModifyCurrencyPopup.vue?vue&type=script&lang=js"
export * from "./ModifyCurrencyPopup.vue?vue&type=script&lang=js"
import style0 from "./ModifyCurrencyPopup.vue?vue&type=style&index=0&id=00a0a23b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports